<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">維修履歷</div>
      <div style="margin-top: 2rem">
        <div class="row">
          <template v-if="detail == false">
            <basic />
          </template>
          <template v-else-if="detail == true">
            <detail />
          </template>
        </div>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import basic from "@/components/deviceManagement/maintainHistory/maintainHistoryQuery/basic.vue";
import detail from "@/components/deviceManagement/maintainHistory/maintainHistoryQuery/detail.vue";
import { computed, provide, ref, watch } from "vue";
import store from "@/store";
export default {
  components: {
    basic,
    detail,
  },
  setup() {
    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const detail = ref(false);
    const maintainData = ref(null);
    const maintenanceHistoryTableFields = ref([
      {
        key: "device",
        label: "機台",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "維修開始時間",
        thStyle: {
          "min-width": "200px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "維修結束時間",
        thStyle: {
          "min-width": "200px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "category",
        label: "維修別",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "description",
        label: "維修說明",
        thStyle: {
          "min-width": "150px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
          "white-space": "pre-line",
        },
      },
      {
        key: "personnel",
        label: "維修人員",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "totalTime",
        label: "維修總時長",
        thStyle: {
          "min-width": "150px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ]);
    const maintenanceHistoryTableItems = ref([
      // {
      //   device: "保溫1",
      //   startTime: "2023-11-13 10:00:00",
      //   endTime: "2023-11-13 12:15:30",
      //   category: "搶修",
      //   description: "測試",
      //   personnel: "小明1號",
      //   totalTime: "2小時15分30秒",
      // },
      // {
      //   device: "環形爐",
      //   startTime: "2023-11-14 13:00:00",
      //   endTime: "2023-11-14 18:20:30",
      //   category: "報修",
      //   description: "測試",
      //   personnel: "小明1號",
      //   totalTime: "5小時20分30秒",
      // },
    ]);
    const queryDate = ref("");
    const deviceName = ref("");
    const exportData = ref([]);

    const getMaintainData = (itemData) => {
      // let maintainData = {
      //   device: itemData.device,
      //   category: itemData.category,
      //   description: itemData.description,
      //   personnel: itemData.personnel,
      //   time: itemData.startTime + " ~ " + itemData.endTime,
      //   appendix: [
      //     {
      //       name: "照片1.jpg",
      //       src: "http://localhost:8080/static/img/user.471fd075.png",
      //     },
      //     { name: "照片2.jpg", src: "#" },
      //     { name: "維修報告.pdf", src: "#" },
      //   ],
      // };
      // return maintainData;
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["abn_start_time"] = itemData.abn_start_time;
      params["deviceID"] = itemData.deviceID;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "GetMaintainDeviceHistoryData";
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;

        if (result["Response"] == "ok") {
          maintainData.value = {
            device: result["QueryTableData"].device,
            // deviceID: result["QueryTableData"].deviceID,
            category: result["QueryTableData"].category,
            description: result["QueryTableData"].description,
            repairReason: result["QueryTableData"].repairReason,
            personnel: result["QueryTableData"].personnel,
            time: result["QueryTableData"].time,
            // abn_start_time: result["QueryTableData"].abn_start_time,
            appendix: result["QueryTableData"].appendix,
          };
          detail.value = true;
        } else {
          methods.setTimeoutAlert("請稍後嘗試");
          detail.value = false;
        }
      });
    };

    const queryMaintenanceHistory = (newValue) => {
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "QueryMaintainHistory";
      params["startTime"] = newValue["date"]["startDate"] + " 00:00:00";
      params["endTime"] = newValue["date"]["endDate"] + " 23:59:59";
      params["deviceID"] = newValue["deviceID"];
      newValue["category"] != undefined
        ? (params["category"] = newValue["category"])
        : "";
      newValue["keyWords"] != undefined
        ? (params["keyWords"] = newValue["keyWords"])
        : "";
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let QueryTableData = result.QueryTableData;
          let Date = result.Date;
          maintenanceHistoryTableItems.value = QueryTableData;
          queryDate.value = Date;
        } else {
          maintenanceHistoryTableItems.value = [];
          queryDate.value = "";
          methods.setTimeoutAlert(response);
        }
        methods.triggerLoadingBar();
      });
    };
    const maintenanceHistoryRowClick = (itemData) => {
      getMaintainData(itemData);
    };

    watch(maintenanceHistoryTableItems, (newValue) => {
      let newExportData = [];
      if (newValue.length == 0) {
        deviceName.value = "";
        exportData.value = [];
        return;
      }
      deviceName.value = newValue[0].device;
      newValue.forEach((data) => {
        let newData = {};
        maintenanceHistoryTableFields.value.map((item) => {
          if (item.key == "category") {
            if (data[item.key] == "3") {
              newData[item.key] = "搶修";
            } else {
              newData[item.key] = "報修";
            }
          } else {
            if (
              typeof data[item.key] === "string" &&
              data[item.key].includes(",")
            ) {
              newData[item.key] = `"${data[item.key]}"`;
            } else {
              newData[item.key] = data[item.key];
            }
          }
        });
        newExportData.push(newData);
      });
      exportData.value = newExportData;
    });

    const commonMethods = {
      maintenanceHistoryRowClick: maintenanceHistoryRowClick,
      queryMaintenanceHistory: queryMaintenanceHistory,
      getMaintainData: getMaintainData,
    };

    provide("detail", detail);
    provide("maintainData", maintainData);
    provide("commonMethods", commonMethods);
    provide("maintenanceHistoryTableFields", maintenanceHistoryTableFields);
    provide("maintenanceHistoryTableItems", maintenanceHistoryTableItems);
    provide("queryDate", queryDate);
    provide("deviceName", deviceName);
    provide("exportData", exportData);
    return {
      detail,
      maintenanceHistoryRowClick,
      maintainData,
    };
  },
};
</script>

<style></style>
